module.exports = __webpack_public_path__ + "static/media/Brenna P.46db25a9.jpg";